import { createSelector } from '@reduxjs/toolkit';
import { selfBlocksSelector } from './self';

const sourcesWithPrioritySelector = createSelector(selfBlocksSelector, (sourcesWithPriority) => sourcesWithPriority.sourcesWithPriority);

export default sourcesWithPrioritySelector;
